import React, { useContext } from 'react';
import { useEffect } from 'react';
import { ToolbarContext } from '../../contexts/toolbar-context';
import { parseISO } from 'date-fns';
import { format } from 'date-fns';
import {Accordion, AccordionDetails, AccordionSummary, Button, ButtonGroup, TextField} from "@mui/material";
import {FixedField} from "../../components/FixedField";
import {SalesTeamSelect} from "../../components/MaterialSelects/SalesTeamSelect";
import {RoleSelect} from "../../components/MaterialSelects/RoleSelect";
import WaitSpinner from "../../components/wait-spinner";
import {useParams} from "react-router";
import { UserSelect } from '../../components/MaterialSelects/UserSelect';

// eslint-disable-next-line react/display-name
export const UserForm = ({diaForm,readOnly}) => {
    const {values,errors,handleSubmit,onChange,isDirty,setValue,status} = diaForm;
    const id = useParams().id;
    const isNew = id === 'new';
    const toolbarContext = useContext(ToolbarContext);
    const doSave = () => {
        handleSubmit();
    };
    const field = {
        onChange: onChange,
        readOnly: readOnly
    };
    useEffect(() => {
        const buttons = [];
        if(!readOnly) {
            buttons.push({
                type: 'button',
                icon: 'save',
                tooltip: 'Save',
                callback: doSave,
                label: 'Save',
                style: 'primary',
                disabled: !isDirty
            });
        }
        toolbarContext.setSecondary(
            {
                title: (status=='loading'?<span></span>:(!isNew ? '' + values?.name : 'New User')),
                secondary: buttons,
                secondaryUrl: id
            });
        //return;
    }, [id, values?.name, isDirty, status,readOnly]);
    if(status=='loading') {
        return <WaitSpinner variant="panel"/>;
    }
    const lockedOutDate = values.lockout_until ? parseISO(values.lockout_until + 'Z') : null;
    const lockedOutDateVal = lockedOutDate > new Date() ? format(lockedOutDate, 'H:mm') : false;
    console.log('values are',values);
    return (
        <Accordion defaultExpanded={true}>
            {(diaForm.status != 'ready' || (id!=values.id && !isNew)) &&
                <WaitSpinner variant="overlay"/>
            }
            <AccordionSummary>
                User
            </AccordionSummary>
            <AccordionDetails className="grid12">
                <TextField label="Email" name="email" type="email" {...field} value={values?.email} error={!!errors?.email}/>
                <TextField label="Name" name="name" {...field} value={values?.name} error={!!errors?.name}/>
                <TextField label="Password" name="password" {...field} value={values?.password??''} error={!!errors?.password}/>
                <RoleSelect name="role" {...field} value={values?.role}  error={!!errors?.role} label="Role"/>
                <SalesTeamSelect name="salesTeams" {...field} value={values.salesTeams} intent={!!errors?.salesTeams} multiple={true} label="Sales Teams" />
                <FixedField label="Status" value={
                    (values.failed_password_count??'0')+' consecutive login attempt failures, '+(values.failed_2fa_count??'0')+' consecutive 2FA failures.  '+(lockedOutDateVal?' User login has been locked until '+lockedOutDateVal:'')}
                />
                <UserSelect name="proxyUser" {...field} value={values?.proxyUser}  error={!!errors?.proxyUser} label="Proxy User" allowBlank={true}/>
                <ButtonGroup>
                    {values.hasAuthenticatorQrCode &&
                        <Button disabled={readOnly} onClick={()=>{setValue('hasAuthenticatorQrCode',false)}}>Clear Registered Authenticator</Button>
                    }
                    {values.lockout_until &&
                        <Button disabled={readOnly ||!values.lockout_until} onClick={()=>{setValue('lockout_until','')}}>Clear lock-out and reset failure counts</Button>
                    }
                </ButtonGroup>
            </AccordionDetails>
        </Accordion>
    );
};



